import { Component, OnInit } from '@angular/core';

interface UnionStatusData {
  status: string;
  unionName: string;
  reason?: string;
  suspendedAt?: string;
}

@Component({
  selector: 'app-union-maintenance',
  templateUrl: './union-maintenance.component.html',
  styleUrls: ['./union-maintenance.component.scss']
})
export class UnionMaintenanceComponent implements OnInit {
  statusData: UnionStatusData | null = null;
  estimatedTime: string = '';

  constructor() {}

  ngOnInit(): void {
    this.loadStatusData();
    this.setEstimatedTime();
  }

  private loadStatusData(): void {
    const storedData = localStorage.getItem('unionStatusData');
    if (storedData) {
      try {
        this.statusData = JSON.parse(storedData);
      } catch (error) {
        console.error('Error parsing union status data:', error);
      }
    }
  }

  private setEstimatedTime(): void {
    // Set estimated completion time (you can customize this logic)
    const now = new Date();
    const estimatedCompletion = new Date(now.getTime() + 2 * 60 * 60 * 1000); // 2 hours from now
    this.estimatedTime = estimatedCompletion.toLocaleTimeString('bn-BD', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }

  formatDate(dateString: string | undefined): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('bn-BD', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  goToLogin(): void {
    window.location.href = '/auth/login';
  }

  refreshPage(): void {
    window.location.reload();
  }

  contactSupport(): void {
    // You can customize this with your actual support contact
    window.open('tel:+8801XXXXXXXXX', '_self');
  }
}